import { z } from "zod";
import { QcUserSchema } from "./conversation/QcUser";
import { QcBizTenantSchema, TenantSchema } from "./Tenant";
import { GroupsSchema, QcBizBelong, QcBizBelongSchema } from "./StaffGroup";

export type QcBizStaffState = z.infer<typeof QcBizStaffStateSchema>;
export const QcBizStaffStateSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  staff_group_id: z.number().optional(),
  staff_id_account: z.number().optional(),
  state: z.string().optional(),
});

export type QueryBizResponder = z.infer<typeof QueryBizResponderSchema>;
export const QueryBizResponderSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  tenant_id: z.number().optional(),
});

export type QcBizStaffGroupState = z.infer<typeof QcBizStaffGroupStateSchema>;
export const QcBizStaffGroupStateSchema = z.object({
  busy_total: z.number().optional(),
  id: z.number().optional(),
  name: z.string().optional(),
  online_total: z.number().optional(),
  order_no: z.number().optional(),
  staff_group_id: z.number().optional(),
  tenant_id: z.number().optional(),
});

export type StaffMyself = z.infer<typeof StaffMyselfSchema>;
export const StaffMyselfSchema = z.object({
  id_account: z.number(),
  tenant_id: z.number(),
  name: z.string(),
  state: z.string(),
  shift: z.string(),
  role: z.string(),
  tenant: TenantSchema,
  user: QcUserSchema,
});

export type StaffStore = {
  myself: StaffMyself;
};

// ================ Handle circular reference via QcBizBelong type ======================
// ======================================================================================

export const QcBizStaffBaseSchema = z.object({
  access_id: z.string().optional(),
  can_communicate_with_sms: z.boolean().optional(),
  department: z.string().optional(),
  email: z.string().optional(),
  group_states: z.array(z.lazy(() => QcBizStaffStateSchema)).optional(),
  id_account: z.number().optional(),
  is_deleted: z.boolean().optional(),
  max_handling_inquiry: z.number().optional(),
  name: z.string().optional(),
  number_handling_inquiry: z.number().optional(),
  position: z.string().optional(),
  responder: z.lazy(() => QueryBizResponderSchema).optional(),
  role: z.string().optional(),
  shift: z.string().optional(),
  state: z.string().optional(),
  tenant: z.lazy(() => QcBizTenantSchema).optional(),
  tenant_id: z.number().optional(),
  user: QcUserSchema.optional(),
});

export type QcBizStaff = z.infer<typeof QcBizStaffBaseSchema> & {
  belongs?: QcBizBelong[];
};
// @ts-ignore complains about the "name" values of "user" not matching, but... it's comparing itself to itself, ergo false-positive?
export const QcBizStaffSchema: z.ZodType<QcBizStaff> = QcBizStaffBaseSchema.extend({
  belongs: z.array(QcBizBelongSchema).optional(),
});

// ======================================================================================
// ======================================================================================

export type Totals = z.infer<typeof TotalsSchema>;
export const TotalsSchema = z.object({
  busy_total: z.number().optional(),
  id: z.number().optional(),
  online_total: z.number().optional(),
});

export type UpdateStaffStateResponse = z.infer<typeof UpdateStaffStateResponseSchema>;
export const UpdateStaffStateResponseSchema = z.object({
  totals: z.array(TotalsSchema),
});

export type StaffLoginStatus = z.infer<typeof StaffLoginStatusSchema>;
export const StaffLoginStatusSchema = z.object({
  default_groups: z.array(GroupsSchema),
  non_default_groups: z.array(GroupsSchema),
});
